import { arrayBuffersEqual } from '../arrayBuffersEqual/arrayBuffersEqual';

export const isFileDuplicated = async (files: File[], file: File) => {
  const fileBuffer = await new Response(file).arrayBuffer();

  for (const f of files) {
    if (f.size !== file.size) {
      continue;
    }

    const fBuffer = await new Response(f).arrayBuffer();

    if (arrayBuffersEqual(fileBuffer, fBuffer)) {
      return true;
    }
  }

  return false;
};
